/** Small display helpers shared by the vendor-quote flow screens. */

/** "YYYY-MM-DD" or ISO → "MM/DD/YYYY"; anything unparseable comes back as is. */
export function formatMdy(value: string): string {
  if (!value) return '';
  const d = new Date(value.length === 10 ? `${value}T12:00:00` : value);
  if (isNaN(d.getTime())) return value;
  return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
}

/** "N quote" / "N quotes" style plural. */
export function plural(n: number, word: string): string {
  return `${n} ${word}${n === 1 ? '' : 's'}`;
}
